import { render, staticRenderFns } from "./flowRole.vue?vue&type=template&id=27c554f8&scoped=true"
import script from "./flowRole.vue?vue&type=script&lang=js"
export * from "./flowRole.vue?vue&type=script&lang=js"
import style0 from "./flowRole.vue?vue&type=style&index=0&id=27c554f8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c554f8",
  null
  
)

export default component.exports